import React from 'react';
import cx from 'classnames';
import { Button } from './Button/index.js';
import Bg from './image/bottom_gradient.png.js';
import styles from './index.module.scss.js';

const BottomMenuMobile = ({
  className,
  style,
  buttons,
  withGradient = false
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, className),
    style: {
      ...style,
      "--count": buttons.length
    }
  },
  buttons.map(({ title, ...button }) => /* @__PURE__ */ React.createElement(
    Button,
    {
      size: "sm",
      ...button,
      isActiveRectFill: button.icon === "casino",
      key: title,
      title
    }
  )),
  withGradient && /* @__PURE__ */ React.createElement("img", { className: styles.gradient, src: Bg, alt: "" })
);
BottomMenuMobile.displayName = "Layout.BottomMenuMobile";

export { BottomMenuMobile };
//# sourceMappingURL=index.js.map
